import React from "react";
import { Form, Typography, Input, DatePicker, Select } from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import PressureSoreTable from "../CommonComponents/ClinicalProgress/PressureSoreModal";
import { prophylaxisKeys } from "../formsKeys";
import useReceptionistMobilePickerProps from "../../../Receptionist/receptionistMobilePickerProps";
const ReviewClinicalProgress = ({
  setPressureSorePoints,
  pressureSorePoints,
  hidePressureSore = false,
}) => {
  const mobilePickerProps = useReceptionistMobilePickerProps();
  return (
    <>
      <Typography>
        <Typography.Text>
          He/She remained cardiovascularly stable, However with a GCS of{" "}
        </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "gcs"]}
        >
          <Input className={inputStyles.mdInput} style={{ width: "150px" }} />
        </Form.Item>
      </Typography>
      <Typography>
        <Typography.Text>During his/her stay at </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "stay"]}
        >
          <Input className={inputStyles.mdInput} />
        </Form.Item>
        <Typography.Text>
          {" "}
          , patient underwent regular physiotherapy and other symptomatic and
          supportive care for his/her functional recovery.
        </Typography.Text>
      </Typography>
      <Typography>
        <Typography.Text>
          Tracheostomy Care and Respiratory Support was continued. As the
          patient condition improved Tracheostomy was successfully decannulated
          on{" "}
        </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "date"]}
        >
          <DatePicker
            className={inputStyles.mdDatePicker}
            style={{ width: "150px" }}
            inputReadOnly
            {...mobilePickerProps}
          />
        </Form.Item>
      </Typography>
      <Typography>
        <Typography.Text>He/She received </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "dvt_prophylaxis"]}
        >
          <Select
            options={prophylaxisKeys}
            className={inputStyles.mdInput}
            style={{ width: "250px" }}
            placeholder="DVT Prophylaxis"
          />
        </Form.Item>
        <Typography.Text> as DVT Prophylaxis</Typography.Text>
      </Typography>
      {!hidePressureSore && (
        <Typography>
          <Typography.Text>
            He/She received regular wound care, with frequent change of
            positioning with medical support for the following Pressure Sores
          </Typography.Text>{" "}
          <PressureSoreTable
            setPressureSorePoints={setPressureSorePoints}
            pressureSorePoints={pressureSorePoints}
          />
        </Typography>
      )}
      <Typography>
        <Typography.Text>
          He/she is being sent for review as advised by the primary physician.
        </Typography.Text>
      </Typography>
    </>
  );
};

export default ReviewClinicalProgress;
